<template>
    <div>
        <el-table :data="tableData" v-loading="tableLoading" border highlight-current-row
                  @current-change="handleCurrentChange" size="small" max-height="200" class="min-table">
            <el-table-column :label="$strings('word/address_id')">
                <template slot-scope="scope">
                    <el-radio v-model="currentRowID" :label="scope.row.group_id">{{ scope.row.group_id }}</el-radio>
                </template>
            </el-table-column>
            <el-table-column prop="group_name" :label="$strings('word/address_name')"></el-table-column>
            <el-table-column prop="cnt" :label="$strings('word/count')"></el-table-column>
            <el-table-column prop="ct_time" :label="$strings('word/ct_time')">
                <template slot-scope="scope">
                    {{ convertUnixToDate(scope.row.ct_time) }}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {CpSiteAddressRead} from "../../../../api/cpsite/api";
import {GetItem} from "../../../../utils/storage";
import {UnixToDateFull} from "../../../../utils/time";
import {STORAGE_KEY_LOGIN_TZ} from "../../../../config/config";

export default {
    name: "addressbook",
    data() {
        return {
            tableLoading: true,
            tableData: [],
            currentRow: {},
            currentRowID: '',
            filter: {group_name: ''},
            pagination: {total: 0, size: 10, page: 1},
        }
    },
    created() {
        this.fetchTableData()
    },
    methods: {
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        handleCurrentChange(val) {
            this.currentRow = val;
            this.currentRowID = val.group_id;
            this.$emit('selectGroupID', val.group_id);
        },
        fetchTableData() {
            this.tableLoading = true;
            this.filter.size = this.pagination.size;
            this.filter.page = this.pagination.page;
            CpSiteAddressRead(this.filter).then((resp) => {
                if (resp.data.data.count === 0) {
                    this.tableData = [];
                    this.pagination.total = 0;
                } else {
                    this.pagination.total = resp.data.data.count;
                    this.tableData = resp.data.data.rows;
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>